export const getSearchIndex = (element) => {
  const selector = '[data-role="search-hit"]'
  const currentHit = element.closest(selector)

  return Array.from(document.querySelectorAll(selector)).findIndex(
    (item) => item === currentHit,
  )
}
